/**
 * @fileoverview Registration documents section. Upload state lives in useDocumentsSection.
 * @module components/AppointmentRegistrationSections/Documents/index
 */
import styles from "./Documents.module.css";
import DocumentUploadField from "./DocumentUploadField.jsx";
import { useDocumentsSection } from "./useDocumentsSection.js";

const Documents = ({
  company,
  onFieldChange,
  onValidationChange,
  missingRequiredFields,
  getFieldValidation,
}) => {
  const {
    t,
    isTablet,
    files,
    errors,
    isUploading,
    isDragging,
    fieldLabels,
    fieldsByRow,
    handleFileChange,
    handleDragOver,
    handleDragLeave,
    handleDrop,
    handleFileClick,
  } = useDocumentsSection({ company, onFieldChange, onValidationChange });

  return (
    <div className={styles.sectionContent}>
      <div className={styles.sectionHeader}>
        <span className={styles.sectionTitle}>
          {t("components.documents.title")}
        </span>
        <div className={styles.sectionDivider}></div>
      </div>
      {fieldsByRow.map((rowFields, rowIndex) => (
        <div key={`documents-row-${rowIndex}`} className={styles.inputRow}>
          {rowFields.map((fieldKey) => (
            <DocumentUploadField
              key={fieldKey}
              fieldKey={fieldKey}
              label={fieldLabels[fieldKey]}
              file={files[fieldKey]}
              uploadError={errors[fieldKey]}
              isUploading={isUploading}
              isDragging={isDragging}
              getFieldValidation={getFieldValidation}
              missingRequiredFields={missingRequiredFields}
              inputId={`${fieldKey}FileInput`}
              onFileChange={(event) => handleFileChange(event, fieldKey)}
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
              onDrop={(event) => handleDrop(event, fieldKey)}
              onClick={() => handleFileClick(`${fieldKey}FileInput`)}
              isTablet={isTablet}
              styles={styles}
            />
          ))}
        </div>
      ))}
    </div>
  );
};

export default Documents;
